import React from "react";
import { EventForDays as EventForDaysBase } from "daymap-react";
import { useDiaryItemClick } from "./useDiaryItemClick";

export interface EventsForDaysProps {
    date: Date;
    studentId?: number;
    hideStudentChip?: boolean;
    onNavigate?: (url: string) => void;
}

export const EventsForDays: React.FC<EventsForDaysProps> = ({ date, studentId, hideStudentChip, onNavigate }) => {
    const { handleItemClick, modalElement } = useDiaryItemClick({ onNavigate });

    return <>
        {modalElement}
        <EventForDaysBase 
            date={date} 
            studentId={studentId} 
            onClick={handleItemClick}
            hideStudentChip={hideStudentChip}
        />
    </>;
};
